import { render, staticRenderFns } from "./PartnersOldPage.vue?vue&type=template&id=8362cbe6&scoped=true&"
import script from "./PartnersOldPage.vue?vue&type=script&lang=js&"
export * from "./PartnersOldPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnersOldPage.vue?vue&type=style&index=0&id=8362cbe6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8362cbe6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTextSection: require('/var/www/app/components/base/BaseTextSection.vue').default})
